export class ExportRooftop {
    checked: boolean;
    id: string;
    title: string;
    constructor(data) {
        this.checked = (data.class === 'm--active') ? true : false;
        this.id = data.id;
        this.title = data.title;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/export-rooftop.ts